export default __webpack_public_path__ + "static/media/co_form_example.19152f28.jpg";